export const BEEKEEPER_SURVEYS = 'surveys_management';
